import { LOCALE_AT } from '@/constants/activity-constants'
import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'
const commonImgProps = {
  className: 'f-first-section__premios-img ',
  alt: 'Presentacion de premios ',
}
function PremiosDO({ isMobile }: { isMobile: boolean }) {
  const imgProps = {
    src: '../../../assets/images/home/premios-do.webp',
  }

  return (
    <StaticImage
      height={185}
      {...commonImgProps}
      {...imgProps}
      placeholder="blurred"
    />
  )
}
function PremiosEC({ isMobile }: { isMobile: boolean }) {
  const imgProps = {
    src: '../../../assets/images/home/premios-ec.webp',
  }

  return (
    <StaticImage
      height={217}
      {...commonImgProps}
      {...imgProps}
      placeholder="blurred"
      className={commonImgProps.className + ' --noMarginBottom'}
    />
  )
}
function PremiosPY({ isMobile }: { isMobile: boolean }) {
  const imgProps = {
    src: '../../../assets/images/home/premios-py.webp',
  }

  return (
    <StaticImage
      height={217}
      {...commonImgProps}
      {...imgProps}
      placeholder="blurred"
      className={commonImgProps.className + ' --noMarginBottom'}
    />
  )
}

function PremiosPR({ isMobile }: { isMobile: boolean }) {
  const imgProps = {
    src: '../../../assets/images/home/premios-pr.webp',
  }

  if (isMobile) {
    return (
      <StaticImage
        height={236}
        {...commonImgProps}
        {...imgProps}
        placeholder="blurred"
      />
    )
  }
  return (
    <StaticImage
      height={360}
      {...commonImgProps}
      {...imgProps}
      placeholder="blurred"
    />
  )
}
function PremiosCL({ isMobile }: { isMobile: boolean }) {
  const imgProps = {
    src: '../../../assets/images/home/premios-cl.webp',
  }

  if (isMobile) {
    return (
      <StaticImage
        height={236}
        {...commonImgProps}
        {...imgProps}
        placeholder="blurred"
      />
    )
  }
  return (
    <StaticImage
      height={360}
      {...commonImgProps}
      {...imgProps}
      placeholder="blurred"
    />
  )
}
function PremiosAR({ isMobile }: { isMobile: boolean }) {
  const imgProps = {
    src: '../../../assets/images/home/premios-ar.webp',
  }

  if (isMobile) {
    return (
      <StaticImage
        height={236}
        {...commonImgProps}
        {...imgProps}
        placeholder="blurred"
      />
    )
  }
  return (
    <StaticImage
      height={360}
      {...commonImgProps}
      {...imgProps}
      placeholder="blurred"
    />
  )
}

function PremiosPE({ isMobile }: { isMobile: boolean }) {
  const imgProps = {
    src: '../../../assets/images/home/premios-pe.webp',
  }

  if (isMobile) {
    return (
      <StaticImage
        height={236}
        {...commonImgProps}
        {...imgProps}
        placeholder="blurred"
      />
    )
  }
  return (
    <StaticImage
      height={360}
      {...commonImgProps}
      {...imgProps}
      placeholder="blurred"
    />
  )
}

function PremiosCO({ isMobile }: { isMobile: boolean }) {
  const imgProps = {
    src: '../../../assets/images/home/premios.png',
  }

  if (isMobile) {
    return (
      <StaticImage
        height={236}
        {...commonImgProps}
        {...imgProps}
        placeholder="blurred"
      />
    )
  }
  return (
    <StaticImage
      height={360}
      {...commonImgProps}
      {...imgProps}
      placeholder="blurred"
    />
  )
}

function Premios({ isMobile }: { isMobile: boolean }) {
  if (LOCALE_AT.PERU) {
    return <PremiosPE isMobile={isMobile} />
  }
  if (LOCALE_AT.ARGENTINA) {
    return <PremiosAR isMobile={isMobile} />
  }
  if (LOCALE_AT.CHILE) {
    return <PremiosCL isMobile={isMobile} />
  }
  if (LOCALE_AT.PUERTO_RICO) {
    return <PremiosPR isMobile={isMobile} />
  }
  if (LOCALE_AT.ECUADOR) {
    return <PremiosEC isMobile={isMobile} />
  }
  if (LOCALE_AT.DOMINICANA) {
    return <PremiosDO isMobile={isMobile} />
  }
  if (LOCALE_AT.PARAGUAY) {
    return <PremiosPY isMobile={isMobile} />
  }

  return <PremiosCO isMobile={isMobile} />
}

export function PremiosBase({ isMobile }: { isMobile: boolean }) {
  const imgProps = {
    className: 'f-first-section__premios-base',
    src: '../../../assets/images/home/base-premios.png',
    alt: 'Base donde estan la presentacion de premios ',
    role: 'img',
  }
  if (isMobile) {
    return <StaticImage width={448} {...imgProps} placeholder="blurred" />
  }
  return <StaticImage width={606} {...imgProps} placeholder="blurred" />
}
function PillDescription({
  children,
  orientation = '',
}: {
  children: React.ReactNode
  orientation?: string
}) {
  return <div className={'pill-description ' + orientation}>{children}</div>
}
function PremiosDescription() {
  if (LOCALE_AT.PERU) {
    return (
      <p>
        1 organizador de lapiceros + 1 bolsa de agua caliente + 1 tomatodo
        rosado + 1 kit de productos Nosotras®
      </p>
    )
  }
  if (LOCALE_AT.ARGENTINA) {
    return (
      <p>
        1 manta Nosotras® Buenas Noches +1 cuaderno Nosotras® + 1 pendrive
        Nosotras® + 1 kit de productos Nosotras®
      </p>
    )
  }
  if (LOCALE_AT.CHILE) {
    return (
      <p>
        1 mochila + 1 cuaderno + 1 pulsera Loving + 1 kit de productos
        Nosotras®
      </p>
    )
  }
  if (LOCALE_AT.PARAGUAY) {
    return (
      <p>
        1 Cuaderno+ 1 Kit de pinceles 1 Botella Nosotras® + 1 Kit de productos
        Nosotras®
      </p>
    )
  }
  return null
}
function PillDescriptionGroup() {
  if (LOCALE_AT.COLOMBIA) {
    return (
      <>
        <PillDescription orientation="left">
          1 kit de productos Nosotras®
        </PillDescription>
        <PillDescription orientation="right">
          1 cuaderno Nosotras®
        </PillDescription>
      </>
    )
  }

  return null
}
function ImagenesDeReferenciaText() {
  if (LOCALE_AT.ARGENTINA) {
    return <i>*Imágenes ilustrativas</i>
  }
  return <i>*Imágenes de referencia</i>
}
export default function PremiosWrapper({ isMobile }: { isMobile: boolean }) {
  if (LOCALE_AT.URUGUAY) {
    return (
      <div className="f-first-section__premios-wrapper">
        <div className="f-first-section__premios-base-wrapper">
          <PremiosBase isMobile={isMobile} />
        </div>
      </div>
    )
  }
  return (
    <div className="f-first-section__premios-wrapper">
      <div className="f-first-section__premios-description-wrapper">
        <PremiosDescription />
      </div>
      <div className="f-first-section__premios-img-wrapper">
        <div className=" animation-wrapper float-no-shadow-animation">
          <PillDescriptionGroup />
          <Premios isMobile={isMobile} />
        </div>
      </div>
      <div className="f-first-section__premios-base-wrapper">
        <PremiosBase isMobile={isMobile} />
      </div>
      <ImagenesDeReferenciaText />
    </div>
  )
}
